module.exports = __webpack_public_path__ + "media/src/images/icons/file_types/docx-9f198c65e51fd73779a2ad850f58ee29.svg";